import { container } from "tsyringe";
import toValidationError from "utils/toValidationError";
import QuestionApi from "api/clapaction/projects/[id]/config/question/QuestionApi";
import QuestionResponseResource from "common/resources/Project/Config/Vote/QuestionResponseResource";
import QuestionRequestResource from "common/resources/Project/Config/Vote/QuestionRequestResource";

export default class QuestionService {
	private api: QuestionApi = container.resolve(QuestionApi);

	public async getAllGeneral(projectId: string): Promise<QuestionResponseResource[]> {
		return this.api
			.getAllGeneral(projectId)
			.catch(toValidationError)
			.then((response) => QuestionResponseResource.hydrateArray<QuestionResponseResource>(response));
	}

	public async getAllCasting(projectId: string): Promise<QuestionResponseResource[]> {
		return this.api
			.getAllCasting(projectId)
			.catch(toValidationError)
			.then((response) => QuestionResponseResource.hydrateArray<QuestionResponseResource>(response));
	}

	public async create(projectId: string, data: QuestionRequestResource): Promise<QuestionResponseResource> {
		return this.api
			.create(projectId, data)
			.catch(toValidationError)
			.then((response) => QuestionResponseResource.hydrate<QuestionResponseResource>(response));
	}

	public async update(projectId: string, questionId: string, data: QuestionRequestResource): Promise<QuestionResponseResource> {
		return this.api
			.update(projectId, questionId, data)
			.catch(toValidationError)
			.then((response) => QuestionResponseResource.hydrate<QuestionResponseResource>(response));
	}

	public async delete(projectId: string, questionId: string): Promise<void> {
		return this.api.delete(projectId, questionId).catch(toValidationError);
	}
}
